import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import DashHeader from "./DashHeader";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

import { LinkContainer } from "react-router-bootstrap";

function InvestmentReadiness() {
  const [formStep, setFormStep] = useState(1);

  const { userInfo } = useSelector((state) => state.userLogin);


  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;
  /*   const date = new Date().toDateString(); */

  /* Configs */

  const api_secret_key = "TDNMSwa7U1p56gg6gEnH";
  // eslint-disable-next-line
  const doc_template_id = "8F2195B3-0D88-4F5D-9ED0-8EB32145AFA8";
  const doctype_id = "LAC_V1.5 - INVESTMENT READINESS";

  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo?.token}`,
    },
  };

  const pdfMonkeyConfig = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${api_secret_key}`,
    },
  };

  /*  Adding IR date
  
 */
  const formik = useFormik({
    initialValues: {
      formType: "investment_readiness",
      team: 0,
      problemAndVision: 0,
      valueProposition: 0,
      product: 0,
      market: 0,
      businessModel: 0,
      scale: 0,
      exit: 0,
    },
    onSubmit: (values) => {
      const allValues = values;

      const total =
        parseInt(formik.values.team) +
        parseInt(formik.values.problemAndVision) +
        parseInt(formik.values.valueProposition) +
        parseInt(formik.values.product) +
        parseInt(formik.values.market) +
        parseInt(formik.values.businessModel) +
        parseInt(formik.values.exit) +
        parseInt(formik.values.scale);
      const average = (Math.round(total / 8));

      console.log("total", total);

      allValues["userId"] = userInfo.id;
      allValues["company_id"] = userInfo.email;
      allValues["doctype_id"] = doctype_id;
      allValues["company_name"] = sme.name;
      allValues["name"] = userInfo.name;
      allValues["score"] = average;
      let score = ""
      setFormStep((formStep) => formStep + 1);

      if ((average === 0)) {
         score = "Incomplete";
      }
      if ((average === 1)) {
         score = "Stage 1";
      }
      if ((average === 2)) {
         score = "Stage 2";
      }
      if ((average === 3)) {
         score = "Stage 3";
      }
      if ((average === 4)) {
         score = "Stage 4";
      }
      if ((average === 5)) {
         score = "Stage 5";
      }
      if ((average === 6)) {
         score = "Stage 6";
      }
      if ((average === 7)) {
         score = "Stage 7";
      }
      if ((average === 8)) {
         score = "Stage 8";
      }
      if ((average === 9)) {
         score = "Stage 9";
      }
      
      /* update IR Score */
      axios.put(
        "/api/users/investment-readiness-score-update/",
        {
          score: score,
        },
        config
      );

      axios
        .post(
          "https://api.pdfmonkey.io/api/v1/documents/",
          {
            document: {
              document_template_id: "A4820DD4-D77B-481A-9756-41FC9A820253",
              payload: allValues,
              status: "pending",
            },
          },
          pdfMonkeyConfig
        )
        .then(function (response) {
          console.log("Response Received");
        })
        .catch(function (error) {
          console.log("Error Occured");
        });
    },
    validationSchema: Yup.object({}),
  });

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <Helmet>
        <title>Investment Readiness Check</title>
        <meta
          name="description"
          content="Lacoona Legal helps you assess your investment readiness ."
        />
        <link rel="canonical" href="/dashboard/investment-readiness" />
      </Helmet>
      <DashHeader pageTitle={"Investment Readiness"} />
      <Row className="dashboard-content-container">
        <Row className="find-lawyer-hero px-5">
          <Col lg={8} className="">
            <Row>
              <h1 className="serious-font">Investment Readiness Check</h1>
            </Row>
            <Row>
              <p>
                Complete the form to get an Investment Readiness assessment
                mailed to your inbox.
              </p>
            </Row>
          </Col>
        </Row>
        <Col>
          <LinkContainer to={"/dashboard/legal-checks"}>
            <button className="lcn-button-orange py-2 px-4 m-4">Back</button>
          </LinkContainer>
        </Col>
        <Row className="find-a-lawyer-form-container">
          {formStep === 1 && (
            <Col className="form-step" lg={8}>
              <Row>
                <Col>
                  <h4 className="form-step-heading">Business Assessment</h4>
                </Col>
              </Row>
              <Form>
                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your business team?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="team"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have two or more co-founders with different skills sets
                    </option>
                    <option value="2">
                      Our team has personally experienced the problem that we
                      are trying to solve
                    </option>
                    <option value="3">
                      Our team is able to build the product and we understand
                      the value chain
                    </option>
                    <option value="4">
                      Our team understands how the market operates and we have
                      strong industry contacts
                    </option>
                    <option value="5">
                      Our team has a clear strategy and understanding of sales
                    </option>
                    <option value="6">
                      Our product and sales team is ready for growth
                    </option>
                    <option value="7">
                      We have an executive team that can lead the company to
                      growth
                    </option>
                    <option value="8">
                      Our team is recognised as a market leader in the industry
                    </option>
                    <option value="9">
                      Our team is able to navigate a merger, acquisition or
                      initial public offering (IPO)
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your business problem and
                    vision?
                  </p>
                  <Form.Select
                    onChange={formik.handleChange}
                    name="problemAndVision"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have identified a specific important and large problem
                    </option>
                    <option value="2">
                      We have a vision for solving a problem and are able to act
                      on this
                    </option>
                    <option value="3">
                      We can explain why our vision offers a superior value
                      proposition compared to what the market currently offers
                    </option>
                    <option value="4">
                      We can explain how our solution will transform the
                      industry
                    </option>
                    <option value="5">
                      We have evidence that our product is solving our
                      customers' problem
                    </option>
                    <option value="6">
                      Our vision is being realised with early adopters and our
                      business is gaining ground.
                    </option>
                    <option value="7">
                      Our vision is proving to be attainable in a major market
                    </option>
                    <option value="8">
                      We are beginning to have systems-level changes in solving
                      the problem
                    </option>
                    <option value="9">
                      We are a global leader in solving this problem
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your business's value
                    proposition?
                  </p>
                  <Form.Select
                    onChange={formik.handleChange}
                    name="valueProposition"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have a theory for how we will solve the problem
                    </option>
                    <option value="2">
                      We have potential customers who validate that our solution
                      will solve a key problem
                    </option>
                    <option value="3">
                      We have evidence that customers will pay our target price
                    </option>
                    <option value="4">
                      Customer feedback shows that our solution is better than
                      others
                    </option>
                    <option value="5">
                      Our initial target customers love the product or service
                      and keep using it
                    </option>
                    <option value="6">
                      We are selling beyond our initial target customers
                    </option>
                    <option value="7">
                      The majority of our sales in our initial market are
                      inbound (this is where potential customers are contacting
                      you to ask about a product or service)
                    </option>
                    <option value="8">
                      Customers are renewing or repurchasubg our product or
                      service without much sales effort
                    </option>
                    <option value="9">
                      We are recognised as the top solution to this problem
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your product or service?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="product"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have the ability to develop a basic prototype (also
                      called a low-fidelity prototype)
                    </option>
                    <option value="2">
                      We have built a basic (low-fidelity) prototype
                    </option>
                    <option value="3">
                      We have built a working prototype and have a product
                      roadmap
                    </option>
                    <option value="4">
                      Our team understands product management and its associated
                      costs
                    </option>
                    <option value="5">
                      Our product is almost ready for broad commercial
                      distribution
                    </option>
                    <option value="6">
                      Our core product is complete and is in the market and
                      gathering feedback
                    </option>
                    <option value="7">
                      Our product is built for scale and new offerings are in
                      progress
                    </option>
                    <option value="8">
                      Our product is succeessfully handling dramatic growth
                    </option>
                    <option value="9">
                      Our product is recognised as the top in the industry
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of the market for your product or
                    service?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="market"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We know the size of our total potential market and target
                      market share
                    </option>
                    <option value="2">
                      We understand what regulations apply and have a strategy
                      for compliance
                    </option>
                    <option value="3">
                      Our initial sales provide evidence that we can capture our
                      target market
                    </option>
                    <option value="4">
                      We have evidence that our total potential market is big
                      enough
                    </option>
                    <option value="5">
                      Large partners are talking to us about distribution,
                      marketing, etc
                    </option>
                    <option value="6">
                      Our suppliers and distributors see meaningful benefits
                      from our success
                    </option>
                    <option value="7">
                      Our sales cycle meets or beats the industry standard
                    </option>
                    <option value="8">
                      We have hard-to-beat partnerships for distribution,
                      marketing, growth
                    </option>
                    <option value="9">
                      We can clearly see our way towards being dominant in the
                      industry
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your business revenue model?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="businessModel"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have an outline of a business revenue model
                    </option>
                    <option value="2">
                      Existing pricing and business models support our revenue
                      model
                    </option>
                    <option value="3">
                      We can explain the cost structure & unit economics in our
                      industry
                    </option>
                    <option value="4">
                      We have projected revenues and costs and have a strategy
                      to reach them
                    </option>
                    <option value="5">
                      Our actual revenues & costs support future positive growth
                    </option>
                    <option value="6">
                      Our customer acquisition costs are going down & pricing is
                      going up
                    </option>
                    <option value="7">
                      We've validated our business model. We have strong 'unit
                      economics' (this is an item that adds value to your
                      business)
                    </option>
                    <option value="8">
                      We are rapidly growing each month and we've got a path to
                      profitability
                    </option>
                    <option value="9">
                      Our revenue has met or exceeded our investors' targets for
                      multiple years
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of the scaleability of your
                    business?
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="scale"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We have identified multiple possible markets or customer
                      segments
                    </option>
                    <option value="2">
                      We have evidence that multiple markets experience this
                      problem
                    </option>
                    <option value="3">
                      We have a clear strategy to scale to multiple markets
                    </option>
                    <option value="4">
                      Customers in multiple markets find value in our solution
                    </option>
                    <option value="5">
                      Our unit economics (an item that adds value to your
                      business) are tipping to positive in at least two markets
                    </option>
                    <option value="6">
                      We have cleared regulatory challenges and have a clear
                      Intellectural Property (IP) strategy
                    </option>
                    <option value="7">
                      Our unit economics are positive in multiple markets
                    </option>
                    <option value="8">
                      Growth in our customer base is accelerating month-on-month
                    </option>
                    <option value="9">
                      Unit economics are strong for multiple markets or customer
                      segments
                    </option>
                  </Form.Select>
                </div>

                <div className="find-a-lawyer-form-question">
                  <p className="col-5 mx-3">
                    What is the current stage of your exit strategy??
                  </p>
                  <Form.Select
                    required
                    onChange={formik.handleChange}
                    name="exit"
                    aria-label="Default select example"
                    className="mb-3"
                    defaultValue={"DEFAULT"}
                  >
                    <option value="DEFAULT" disabled>
                      Select...
                    </option>

                    <option value="1">
                      We know what an exit is and understand its importance to
                      investors
                    </option>
                    <option value="2">
                      We have a vision of how to we can deliver liquidity to
                      investors in the longer term
                    </option>
                    <option value="3">
                      Evidence suggests our value proposition is of interest to
                      acquirers (a registered company looking to buy a portion
                      or the rights to your company)
                    </option>
                    <option value="4">
                      Serious companies have made serious investments in our
                      industry
                    </option>
                    <option value="5">
                      We’re seeing inbound interest (people approaching you)
                      from large potential acquirers
                    </option>
                    <option value="6">
                      We’ve identified specific acquirers or other exit options
                    </option>
                    <option value="7">
                      We have strong relationships with multiple potential
                      acquirers
                    </option>
                    <option value="8">
                      We have turned down an acquisition offer already
                    </option>
                    <option value="9">
                      We are on the point of an exit and reaching the finish
                      line
                    </option>
                  </Form.Select>
                </div>
              </Form>

              <Row>
                <Col className="form-step-next-button-container">
                  <button
                    className="lcn-button-orange py-2 px-4"
                    onClick={formik.submitForm}
                    type="submit"
                  >
                    Submit
                  </button>
                </Col>
              </Row>
            </Col>
          )}
        </Row>

        {formStep === 2 && (
          <Col className="form-step" lg={12}>
            <Row>
              <h4 className="form-step-heading text-center">
                Thank you for your submission. You will receive your Investment
                Readiness Report feedback in your mailbox.
              </h4>
            </Row>
          </Col>
        )}
      </Row>
    </Col>
  );
}

export default InvestmentReadiness;
